//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.EntityPropTableBuilder.js";
let d=[[],[],[]];
SPLM.Motion.BearingPropertyBuilder = class extends SPLM.Motion.EntityPropTableBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.BearingPropertyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.BearingPropertyBuilder.BearingType = Object.freeze({
    "Standard" : "Standard", "DeepGrooveBall" : "DeepGrooveBall", "AngularContactBall" : "AngularContactBall", "ThrustBall" : "ThrustBall", "CylindricalRoller" : "CylindricalRoller", "TaperedRoller" : "TaperedRoller", "ThrustNeedle" : "ThrustNeedle", "FourPointContactBall" : "FourPointContactBall"});

SPLM.Motion.BearingPropertyBuilder.ReferenceRing = Object.freeze({
    "Inner" : "Inner", "Outer" : "Outer"});

SPLM.Motion.BearingPropertyBuilder.LocalComplianceType = Object.freeze({
    "Dry" : "Dry", "Wet" : "Wet", "WetD" : "WetD"});

SPLM.Motion.BearingPropertyBuilder.MicrogeometryType = Object.freeze({
    "Profile2d" : "Profile2d", "Function" : "Function"});

SPLM.Motion.BearingPropertyBuilder.DiagonalDampingType = Object.freeze({
    "Absolute" : "Absolute", "VariablePercentage" : "VariablePercentage", "ConstantPercentage" : "ConstantPercentage"});

SPLM.Motion.BearingPropertyBuilder.VisualizationType = Object.freeze({
    "Automatic" : "Automatic", "Customized" : "Customized"});

export default SPLM;